// extracted by mini-css-extract-plugin
export default {"SidebarNav":"SidebarNav1m77dpeMGqra","SidebarNav_loading":"SidebarNav_loading3qnZOghor52v"};